// eslint-disable-next-line import/no-extraneous-dependencies
import "whatwg-fetch";

export const REQUEST_RECURRING = "REQUEST_RECURRING";
export const RECEIVE_RECURRING = "RECEIVE_RECURRING";
export const RECEIVE_ERROR = "RECEIVE_ERROR";

function requestRecurring(uuid) {
  return {
    type: REQUEST_RECURRING,
    uuid
  };
}

function receiveRecurring(recurring) {
  return {
    type: RECEIVE_RECURRING,
    recurring
  };
}

function receiveError(message) {
  return {
    type: RECEIVE_ERROR,
    message
  };
}

export function fetchRecurring(uuid) {
  return dispatch => {
    dispatch(requestRecurring(uuid));

    return window
      .fetch(`/public/recurring/${uuid}`)
      .then(
        resp => resp.json(),
        error => {
          if (error instanceof TypeError) {
            setTimeout(() => {
              dispatch(fetchRecurring(uuid));
            }, 1000);
          } else {
            dispatch(receiveError(error.message));
          }
        }
      )
      .then(json => {
        if (json) {
          if (json.error) {
            dispatch(receiveError(json.error));
          }
          dispatch(receiveRecurring(json));
        }
      });
  };
}
